module.exports = __webpack_public_path__ + "static/img/letterheadkpdn.369bdef.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/mydiesel/letterheadkpdn.png
// module id = DGEk
// module chunks = 107